export const changeStepper = async (e: any, newCurrentStep: number, props: any) => {
    await props.validate();
    if (props.formik.isValid || e.target.name === "previous") {
        props.setShowErrorsInputs(false);
        props.setStepper({
            ...props.stepper,
            previous: newCurrentStep === props.stepper.firstStep ? 0 : newCurrentStep - 1,
            current: newCurrentStep,
            next:
                newCurrentStep !== props.stepper.lastStep
                    ? newCurrentStep + 1
                    : props.stepper.lastStep,
        });
    } else {
        props.setErrorIncompleteFields(true);
        props.setShowErrorsInputs(true);
    }
};